export default "__VITE_ASSET__QDYQJqw0__"